import { FC } from "react";
import styles from "./ManagementExample.module.scss";
import { H2 } from "../../../../components/Typography";
import { useTranslation } from "next-i18next";
import { Button } from "../../../../components/Buttons";
import Image from "next/image";
import { FeedBackModalNew } from "../../../../components/Modal";

interface IManagementExample {}
export const ManagementExample: FC<IManagementExample> = () => {
  const { t } = useTranslation("index", { keyPrefix: "managementPage.example" });
  const openModal = async () => {
    const modal = await import("../../../../components/Modal/ModalConnector").then(
      (p) => p.modal,
    );
    modal.open(
    <FeedBackModalNew 
      eventName={["others"]} 
      leadType="COOP"
      title="getReportExample"
      comment="Получить шаблон отчета"
      sourceForm="request_report_example"
      url="https://docs.google.com/spreadsheets/d/1H-DHfqapcDrmB0JREHJz1BUWnNST17hk/edit?usp=sharing&ouid=101829202854839061105&rtpof=true&sd=true"
    />, { isFeedBackNew: true });
  };
  return (
    <div className={styles.example}>
      <div className={styles.example__content}>
        <H2>{t("title")}</H2>
        <Button
          label={t("button")}
          as={"button"}
          size="lg"
          theme="light-invert"
          onClick={() => openModal()}
        />
      </div>
      <div className={styles.example__imageWrapper}>
        <Image
          src={"/images/management/example.webp"}
          className={styles.example__image}
          loader={({ src }) => src}
          width={933}
          height={618}
          alt="example"
        />
      </div>
    </div>
  );
};
